var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4278_10361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48C11.2663 48 0.5 37.2337 0.5 24C0.5 10.7663 11.2663 0 24.5 0C37.7337 0 48.5 10.7663 48.5 24C48.5 37.2337 37.7337 48 24.5 48ZM24.5 2.28571C12.5268 2.28571 2.78571 12.0268 2.78571 24C2.78571 35.9732 12.5268 45.7143 24.5 45.7143C36.4732 45.7143 46.2143 35.9732 46.2143 24C46.2143 12.0268 36.4732 2.28571 24.5 2.28571Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22C19.1569 22 20.5 20.6569 20.5 19C20.5 17.3431 19.1569 16 17.5 16C15.8431 16 14.5 17.3431 14.5 19C14.5 20.6569 15.8431 22 17.5 22Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 22C33.1569 22 34.5 20.6569 34.5 19C34.5 17.3431 33.1569 16 31.5 16C29.8431 16 28.5 17.3431 28.5 19C28.5 20.6569 29.8431 22 31.5 22Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4577 35.9997C31.084 35.9997 30.7241 35.7444 30.5352 35.2931C29.3437 32.4389 27.0311 30.6666 24.5 30.6666C21.9689 30.6666 19.6565 32.4391 18.4648 35.2931C18.1931 35.9441 17.5627 36.1888 17.0533 35.8434C16.5438 35.4962 16.3522 34.689 16.6225 34.0398C18.1782 30.3142 21.1958 28 24.5 28C27.8042 28 30.8218 30.3142 32.3775 34.0398C32.6478 34.689 32.4562 35.4962 31.9467 35.8434C31.7905 35.9494 31.6235 35.9997 31.4577 35.9997Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4278_10361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadError);
export default __webpack_public_path__ + "static/media/load-error.c9fa029c906b8fb68ca586662f060166.svg";
export { ForwardRef as ReactComponent };